export class Csave {
  TestCaseList: Array<any>;
  TestedPerson: any;
  TestReason: string;
  PaymentMethod: number;
  AcceptionNumber: string;
  constructor() {
    this.TestCaseList = [],
      this.TestedPerson = {},
      this.TestReason=''
  }
}
